/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AzureManagementGroup } from '../models/AzureManagementGroup';
import { AzureSubscription } from '../models/AzureSubscription';
import { OnboardingAzureResourceGroup } from '../models/OnboardingAzureResourceGroup';

export class AzureOnboardingRequest {
  /**
  * The account type - restore \\ source
  */
  'accountType': AzureOnboardingRequestAccountTypeEnum;
  /**
  * The tenant id
  */
  'tenantId': string;
  'managementGroups'?: Array<AzureManagementGroup>;
  'subscriptions'?: Array<AzureSubscription>;
  'resourceGroups'?: Array<OnboardingAzureResourceGroup>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "accountType",
      "baseName": "accountType",
      "type": "AzureOnboardingRequestAccountTypeEnum",
      "format": ""
    },
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": ""
    },
    {
      "name": "managementGroups",
      "baseName": "managementGroups",
      "type": "Array<AzureManagementGroup>",
      "format": ""
    },
    {
      "name": "subscriptions",
      "baseName": "subscriptions",
      "type": "Array<AzureSubscription>",
      "format": ""
    },
    {
      "name": "resourceGroups",
      "baseName": "resourceGroups",
      "type": "Array<OnboardingAzureResourceGroup>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureOnboardingRequest.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum AzureOnboardingRequestAccountTypeEnum {
  Restore = 'restore',
  Source = 'source',
  Scanning = 'scanning',
  Vault = 'vault'
}

